/* Shared "Join the movement" form (snippets/movement-capture.liquid). Claude-owned, 2026-10-05.
   Mirrors /pages/movement: list TB5UFa + "Joined Weekly Newsletter" (entry = data-src), then an
   optional SMS step ("Movement SMS Opt-in"). Safe to load more than once per page. */
(function(){
  'use strict';
  var API='https://a.klaviyo.com/client/', CO='VgVM2W', LIST='TB5UFa';
  var ARROW=' <span aria-hidden="true">&rarr;</span>';
  function post(path,body){
    return fetch(API+path+'?company_id='+CO,{method:'POST',headers:{'Content-Type':'application/json','revision':'2025-04-15'},body:JSON.stringify(body)})
      .then(function(r){ if(r.status!==202 && !r.ok) throw new Error('status '+r.status); return r; });
  }
  function event(name,props,profile){
    return post('events/',{data:{type:'event',attributes:{properties:props,metric:{data:{type:'metric',attributes:{name:name}}},profile:{data:{type:'profile',attributes:profile}}}}}).catch(function(){});
  }
  function normPhone(v){ var d=v.replace(/\D/g,''); if(d.length===10) return '+1'+d; if(d.length===11&&d[0]==='1') return '+'+d; return null; }
  function remember(){ try{ localStorage.setItem('unify_popup_v2',JSON.stringify({captured:Date.now()})); localStorage.setItem('unify_member','1'); }catch(e){} try{ document.dispatchEvent(new CustomEvent('unify:member')); }catch(e){} }

  function wire(root){
    if(root.getAttribute('data-mvc-ready')) return; root.setAttribute('data-mvc-ready','1');
    var q=function(s){return root.querySelector(s);};
    var s1=q('[data-mvc-s1]'), s2=q('[data-mvc-s2]'), s3=q('[data-mvc-s3]');
    var stateEl=q('[data-mvc-state]'), emailEl=q('[data-mvc-email]'), btn=q('[data-mvc-btn]'), err=q('[data-mvc-err]');
    var phoneEl=q('[data-mvc-phone]'), consent=q('[data-mvc-consent]'), btn2=q('[data-mvc-btn2]'), err2=q('[data-mvc-err2]');
    var params=new URLSearchParams(location.search);
    var src=root.getAttribute('data-src')||'site';
    var origin=(params.get('src')||params.get('utm_source')||'').slice(0,40);
    var source=(origin? origin+'>' : '')+src;
    var em='', st='', label=btn.textContent.trim();
    function names(){ var n=(st==='Outside the US')?'your area':st; root.querySelectorAll('[data-mvc-statename]').forEach(function(x){x.textContent=n;}); }
    function show(step){ s1.hidden=step!==1; s2.hidden=step!==2; s3.hidden=step!==3; }

    s1.addEventListener('submit',function(e){
      e.preventDefault(); err.hidden=true;
      function fail(m){ err.textContent=m; err.hidden=false; btn.disabled=false; btn.innerHTML=label+ARROW; }
      st=stateEl.value; em=emailEl.value.trim().toLowerCase();
      if(!st) return fail('Pick your state so we know where you are.');
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) return fail('Double check that email for us.');
      btn.disabled=true; btn.textContent='Joining';
      post('subscriptions/',{data:{type:'subscription',attributes:{custom_source:'Join the movement: '+src,profile:{data:{type:'profile',attributes:{
        email:em, location:{region:st}, properties:{weekly_state:st, weekly_source:source, joined_via:src},
        subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:LIST}}}}})
      .then(function(){
        event('Joined Weekly Newsletter',{state:st,source:source,sms_opt_in:false,entry:src},{email:em});
        remember();
        try{ window.fbq && window.fbq('track','Lead',{content_name:'Join the movement'}); }catch(x){}
        try{ window.Shopify && Shopify.analytics && Shopify.analytics.publish('movement_signup',{state:st,source:source}); }catch(x){}
        names(); show(2); setTimeout(function(){ try{ phoneEl.focus({preventScroll:true}); }catch(x){} },300);
      }).catch(function(){ fail('Something went wrong on our end. Give it another try in a second.'); });
    });

    s2.addEventListener('submit',function(e){
      e.preventDefault(); err2.hidden=true;
      function fail(m){ err2.textContent=m; err2.hidden=false; btn2.disabled=false; btn2.innerHTML='Text me'+ARROW; }
      var ph=normPhone(phoneEl.value);
      if(!ph) return fail('Enter a 10 digit US mobile number.');
      if(!consent.checked) return fail('Check the box so we are allowed to text you.');
      btn2.disabled=true; btn2.textContent='Saving';
      post('subscriptions/',{data:{type:'subscription',attributes:{custom_source:'Join the movement: '+src+' (SMS step)',profile:{data:{type:'profile',attributes:{
        email:em, phone_number:ph, subscriptions:{sms:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:LIST}}}}})
      .then(function(){ event('Movement SMS Opt-in',{state:st,source:source,entry:src},{email:em,phone_number:ph}); show(3); })
      .catch(function(){ fail('We could not save that number. Check it and try again, or tap No thanks.'); });
    });
    q('[data-mvc-skip]').addEventListener('click',function(){ show(3); });
  }
  function init(){ document.querySelectorAll('[data-mvc]').forEach(wire); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
